import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie';

import { HTTPService, HelperService, ValidationService, GeoLocationService } from 'app/services';
import { messages } from 'app/constants';

@Component({
  selector: 'app-forgot-password',
  templateUrl: 'forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent implements OnInit {
  user = { email: '', password: '' };
  validate: any = {};
  disabled: boolean = false;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private cookieService: CookieService,
    private router: Router,
    private validationService: ValidationService,
    private geoLocationService: GeoLocationService,
  ) {}

  ngOnInit(): void {
    const token = this.cookieService.getObject('alpat');
    if (token) {
      const data = this.helperService.jwtDecode(token);
      if (data) {
        this.router.navigate(['../dashboard']);
      }
    }
  }

  onFocus(name) {
    this.validate[name] = '';
  }

  onChange(name, value) {
    this.user[name] = value;
  }

  resetPassword() {
    this.router.navigate(['../login']);
  }

  validateForm() {
    let isValid = true;
    this.validate = {};
    this.user.email = this.user.email.trim()

    if (!this.user.email) {
      this.validate.email = messages.enterEmail;
      isValid = false;
    }

    if (
      this.user.email &&
      this.validationService.validatingEmail(this.user.email)
    ) {
      this.validate.email = messages.inValidEmail;
      isValid = false;
    }

    return isValid;
  }

  fakeTheRequest() {
    setTimeout(() => {
      this.disabled = false;
      this.helperService.showToaster(
        'success',
        'Password reset link has been sent to your email'
      );
    }, 1000);
  }

  onSubmit() {
    if (this.validateForm() && !this.disabled) {
      this.disabled = true;
      this.geoLocationService.getGeoInfo().then((geoInfo) => {
        const payload = {
          geoInfo
        };
        this.httpService.forgotPassword(this.user.email, payload).then(
          (res) => {
            this.disabled = false;
            this.helperService.showToaster(
              'success',
              'Password reset link has been sent to your email'
            );
          },
          (err) => {
            this.disabled = false;
            this.validate.email = err;
          }
        );
      });
    }
  }
}
